import { useMemo } from "react";
import { usePickslipStore } from "../stores/pickslipStore";
import { parsePointsEntered } from "@/features/pickems/util/helpers";
import type { PickemsContestWithMarkets } from "@/hooks/firestore/pickems/usePickemsContest";
import type { ProcessedEntry } from "@/hooks/firestore/betting/useEntries";
import { isPickemsEntry } from "features/entries/util/type-guards";

export const usePotentialPoints = (
  contest: PickemsContestWithMarkets,
  entry?: ProcessedEntry,
): number => {
  const picksInStore = usePickslipStore((s) => s.picks);

  return useMemo(() => {
    if (!contest) return 0;

    const selections = isPickemsEntry(entry)
      ? (entry?.data?.selections ?? [])
      : [];

    return parsePointsEntered(contest, selections, picksInStore);
  }, [contest, entry, picksInStore]);
};
